var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "menuVisibilityModal",
        staticClass: "modal fade menu-visibility-modal",
        attrs: {
          id: "menuVisibilityModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "menuVisibilityModalLabel",
          "aria-hidden": "true",
          "data-backdrop": "static",
          "data-keyboard": "false",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content mv-modal-content" }, [
              _c("div", { staticClass: "mv-header" }, [
                _vm._m(0),
                _vm._m(1),
                _c(
                  "button",
                  {
                    staticClass: "close d-close",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "mv-body" },
                [
                  _c("div", { staticClass: "mv-section-label" }, [
                    _vm._v("PORTAL MODULES"),
                  ]),
                  _c("div", { staticClass: "mv-toggle-list" }, [
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(2),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.surveys,
                                expression: "settings.surveys",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.surveys)
                                ? _vm._i(_vm.settings.surveys, null) > -1
                                : _vm.settings.surveys,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.surveys,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "surveys",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "surveys",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "surveys", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("surveys")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(3),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.wallets,
                                expression: "settings.wallets",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.wallets)
                                ? _vm._i(_vm.settings.wallets, null) > -1
                                : _vm.settings.wallets,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.wallets,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "wallets",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "wallets",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "wallets", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("wallets")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(4),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.package_management,
                                expression: "settings.package_management",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(
                                _vm.settings.package_management
                              )
                                ? _vm._i(
                                    _vm.settings.package_management,
                                    null
                                  ) > -1
                                : _vm.settings.package_management,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.package_management,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "package_management",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "package_management",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.settings,
                                      "package_management",
                                      $$c
                                    )
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("package_management")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(5),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.referrals,
                                expression: "settings.referrals",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.referrals)
                                ? _vm._i(_vm.settings.referrals, null) > -1
                                : _vm.settings.referrals,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.referrals,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "referrals",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "referrals",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "referrals", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("referrals")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(6),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.dietarymodule,
                                expression: "settings.dietarymodule",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.dietarymodule)
                                ? _vm._i(_vm.settings.dietarymodule, null) > -1
                                : _vm.settings.dietarymodule,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.dietarymodule,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "dietarymodule",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "dietarymodule",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "dietarymodule", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("dietarymodule")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(7),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.roster,
                                expression: "settings.roster",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.roster)
                                ? _vm._i(_vm.settings.roster, null) > -1
                                : _vm.settings.roster,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.roster,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "roster",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "roster",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "roster", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("roster")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(8),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.radiology,
                                expression: "settings.radiology",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.radiology)
                                ? _vm._i(_vm.settings.radiology, null) > -1
                                : _vm.settings.radiology,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.radiology,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "radiology",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "radiology",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "radiology", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("radiology")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "mv-toggle-row",
                        class: { "mv-disabled": _vm.saving },
                      },
                      [
                        _vm._m(9),
                        _c("label", { staticClass: "mv-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.pathology,
                                expression: "settings.pathology",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.pathology)
                                ? _vm._i(_vm.settings.pathology, null) > -1
                                : _vm.settings.pathology,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.pathology,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "pathology",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "pathology",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "pathology", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("pathology")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "mv-slider" }),
                        ]),
                      ]
                    ),
                  ]),
                  _c("transition", { attrs: { name: "mv-fade" } }, [
                    _vm.saveMessage
                      ? _c(
                          "div",
                          {
                            staticClass: "mv-save-feedback",
                            class: _vm.saveMessageType,
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.saveMessageType === "success"
                                    ? "check_circle"
                                    : "error"
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.saveMessage) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "mv-footer" }, [
                _vm._m(10),
                _c("div", { staticClass: "mv-footer-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "mv-btn-save primary-btn ripple",
                      attrs: { disabled: _vm.saving },
                      on: { click: _vm.saveSettings },
                    },
                    [
                      _vm.saving
                        ? _c("span", [
                            _c("i", { staticClass: "material-icons mv-spin" }, [
                              _vm._v("autorenew"),
                            ]),
                            _vm._v(" Saving…\n              "),
                          ])
                        : _c("span", [_vm._v("Save Changes")]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-header-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("tune")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-header-text" }, [
      _c("h5", { attrs: { id: "menuVisibilityModalLabel" } }, [
        _vm._v("Options Display"),
      ]),
      _c("p", [_vm._v("Show or hide sidebar modules for this clinic")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon survey-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Surveys")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Survey results, individual & analytics findings"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon wallet-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Wallet")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Recharge wallet, balance & transaction history"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon package-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Package Management")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("List, manage & purchase packages, package reports"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon referrals-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Referrals")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Referred patients list and referral history"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon nutrition-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Diet & Nutrition")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Diet plans, nutrition tracking and dietary consultations"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon roster-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Roster Management")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Manage staff schedules, shifts and roster assignments"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon radiology-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Radiology Portal")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Radiology lab queue and imaging reports"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mv-toggle-info" }, [
      _c("span", { staticClass: "mv-icon pathology-icon" }),
      _c("div", [
        _c("div", { staticClass: "mv-name" }, [_vm._v("Pathology Portal")]),
        _c("div", { staticClass: "mv-desc" }, [
          _vm._v("Pathology lab queue and diagnostic reports"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "mv-footer-note" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(
        "\n            Changes apply immediately for all users on reload\n          "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }